import React from 'react';
import { MenuItem, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { bindMenu } from 'material-ui-popup-state/hooks';
import { usePostHog } from 'posthog-js/react';
import {
  Menu,
  useRemoveBuildingFromSurveyMenuItem,
  FavoriteIconFilled,
  FavoriteIconOutlined,
  NotInterestedIcon,
} from '~/legacy/components';
import { BUILDING_INTEREST } from '~/legacy/consts';
import { BASE_ICON_STYLES } from '../buttons/ButtonUtils';

const useStyles = makeStyles((theme) => ({
  ...BASE_ICON_STYLES(theme),
}));

export const BdpBuildingMenu = ({
  menuState,
  RemoveBuildingFromSurveyMenuItemComponent,
  FavoriteMenuItemComponent,
  NotInterestedMenuItemComponent,
}) => {
  return (
    <Menu {...bindMenu(menuState)} getContentAnchorEl={null}>
      {FavoriteMenuItemComponent}
      {NotInterestedMenuItemComponent}
      {RemoveBuildingFromSurveyMenuItemComponent}
    </Menu>
  );
};

export const useBdpBuildingMenu = ({
  menuState,
  surveyId,
  surveyName,
  buildingId,
  redirect,
  surveyBuilding,
  updateSurveyBuilding,
}) => {
  const classes = useStyles();
  const posthog = usePostHog();

  const isFavorited = surveyBuilding?.interest === BUILDING_INTEREST.FAVORITED;
  const isNotInterested =
    surveyBuilding?.interest === BUILDING_INTEREST.NOT_INTERESTED;

  const {
    RemoveBuildingFromSurveyMenuItemComponent,
    ConfirmRemoveBuildingFromSurveyModalComponent,
  } = useRemoveBuildingFromSurveyMenuItem({
    surveyId,
    surveyName,
    buildingId,
    handleMenuClose: () => menuState.close(),
    redirect,
    label: 'Remove From Survey',
  });

  const FavoriteMenuItemComponent = (
    <MenuItem
      className={classes.menuItemRoot}
      onClick={(e) => {
        e.stopPropagation();
        const newInterest = isFavorited
          ? BUILDING_INTEREST.NEUTRAL
          : BUILDING_INTEREST.FAVORITED;
        updateSurveyBuilding({ interest: newInterest });
        posthog.capture('bdp:broker_favorite_clicked', {
          surveyId,
          buildingId,
          action: isFavorited ? 'remove' : 'add',
        });
        menuState.close();
      }}
    >
      {isFavorited ? (
        <FavoriteIconFilled className={classes.icon} />
      ) : (
        <FavoriteIconOutlined className={classes.icon} />
      )}
      <Typography className={classes.text}>
        {isFavorited ? 'Remove from Favorites' : 'Add to Favorites'}
      </Typography>
    </MenuItem>
  );

  const NotInterestedMenuItemComponent = (
    <MenuItem
      className={classes.menuItemRoot}
      onClick={(e) => {
        e.stopPropagation();
        const newInterest = isNotInterested
          ? BUILDING_INTEREST.NEUTRAL
          : BUILDING_INTEREST.NOT_INTERESTED;
        updateSurveyBuilding({ interest: newInterest });
        posthog.capture('bdp:broker_not_interested_clicked', {
          surveyId,
          buildingId,
          action: isNotInterested ? 'remove' : 'add',
        });
        menuState.close();
      }}
    >
      <NotInterestedIcon className={classes.icon} />
      <Typography className={classes.text}>
        {isNotInterested ? 'Remove not interested' : 'Not interested'}
      </Typography>
    </MenuItem>
  );

  const BdpBuildingMenuComponent = (
    <BdpBuildingMenu
      menuState={menuState}
      RemoveBuildingFromSurveyMenuItemComponent={
        RemoveBuildingFromSurveyMenuItemComponent
      }
      FavoriteMenuItemComponent={FavoriteMenuItemComponent}
      NotInterestedMenuItemComponent={NotInterestedMenuItemComponent}
    />
  );

  return {
    BdpBuildingMenuComponent,
    ConfirmRemoveBuildingFromSurveyModalComponent,
  };
};
